<ng-template #template>
  <div
    class="p-lg-0 card-spacing"
    [ngClass]="'col-lg-' + width"
    style="border-radius: 3px; border: 1px solid #f3694e"
  >
    <div class="h-100">
      <div class="card-body">
        <h2 style="color: #f3694e">Unhandled exception.</h2>
        <div class="table-responsive">
          Component: {{ data?.component }}<br />
          Error: {{ data.error }}
        </div>
      </div>
    </div>
  </div>
</ng-template>
